import React, { useMemo, useState } from "react";
import MyClock from "components/widgets/MyClock";
import { useAuth } from "context/AuthProvider";
import useAxiosFunction from "hooks/useAxiosFunction";
import PopupDialog from "components/dialog/PopupDialog";
import { MyConst } from "data/MyConst";

export default function Topbar({ title, contexts, activeContextId, bootstrapError }) {
  const { switchContext } = useAuth();
  const [, , loading, axiosFetch] = useAxiosFunction();
  const [showRolePopup, setShowRolePopup] = useState(false);
  const contextItems = useMemo(() => (Array.isArray(contexts) ? contexts : []), [contexts]);
  const hasMultipleContexts = contextItems.length > 1;

  const getContextLabel = (item) => {
    const groupCode = String(item?.groupname || "").trim();
    const groupLabel = String(item?.group_description || "").trim() || groupCode;
    const contextName = String(item?.context_name || "").trim();
    const label = String(item?.label || "").trim();
    if (label && groupCode && groupLabel && label.startsWith(`${groupCode} - `)) {
      return label.replace(`${groupCode} - `, `${groupLabel} - `);
    }
    if (label && label !== groupCode) {
      return label;
    }
    if (contextName) {
      return `${groupLabel} - ${contextName}`;
    }
    return groupLabel || label || "-";
  };

  const handleSwitchContext = async (idUserGroup) => {
    if (!idUserGroup || idUserGroup === activeContextId) return;

    const resp = await axiosFetch({
      method: "POST",
      url: "/auth/switch_context",
      auth: true,
      data: { id_user_group: idUserGroup },
      timeout: 15000,
    });

    if (resp?.data?.token) {
      const bootstrapResp = await axiosFetch({
        method: "GET",
        url: "/app/bootstrap",
        auth: true,
        authToken: resp.data.token,
        timeout: 15000,
      });

      if (bootstrapResp?.data?.user) {
        const nextUser = {
          ...resp.data,
          ...bootstrapResp.data.user,
          menus: bootstrapResp.data.menus || [],
          permissions: bootstrapResp.data.permissions || [],
          settings: bootstrapResp.data.settings || {},
          personal_fields: bootstrapResp.data.personal_fields || [],
          app_info: bootstrapResp.data.app || {},
        };
        switchContext({
          ...nextUser,
          bootstrap_ready_key: `${nextUser.uid || ""}:${nextUser.id_user_group || ""}:${nextUser.version || ""}:${MyConst.BOOTSTRAP_SCHEMA_VERSION || ""}`,
        });
      } else {
        switchContext(resp.data);
      }
      setShowRolePopup(false);
    }
  };

  return (
    <nav className="main-header navbar navbar-expand navbar-white navbar-light">
      <ul className="navbar-nav">
        <li className="nav-item">
          <a className="nav-link" data-widget="pushmenu" href="/" onClick={(event) => event.preventDefault()} role="button">
            <i className="fas fa-bars" />
          </a>
        </li>
      </ul>
      <h5 className="mb-0 kms-topbar-context-title">{title}</h5>
      {bootstrapError ? <span className="badge badge-danger ml-3">{bootstrapError}</span> : null}
      <ul className="navbar-nav ml-auto align-items-center pr-2">
        <li className="nav-item mr-3 d-none d-md-block">
          <span className="nav-link">
            <MyClock />
          </span>
        </li>
        {hasMultipleContexts ? (
          <li className="nav-item mr-2">
            <button
              type="button"
              className="btn btn-outline-primary btn-sm kms-role-switch-button"
              onClick={() => setShowRolePopup(true)}
              title="Ganti Peran"
              aria-label="Ganti Peran"
            >
              <i className="fas fa-user-tag kms-role-switch-icon" />
              <span className="kms-role-switch-label">Peran</span>
            </button>
          </li>
        ) : null}
        <li className="nav-item">
          <a className="nav-link px-2" data-widget="fullscreen" href="/" onClick={(event) => event.preventDefault()} role="button" title="Maximize">
            <i className="fas fa-expand-arrows-alt" />
          </a>
        </li>
      </ul>

      <PopupDialog
        size="md"
        title="Ganti Peran"
        show={showRolePopup}
        closeHandle={() => setShowRolePopup(false)}
        allowClose={true}
        closeLabel="Tutup"
      >
        <div className="list-group">
          {contextItems.map((item) => {
            const isActive = item.id_user_group === activeContextId;
            return (
              <button
                key={item.id_user_group}
                type="button"
                className={`list-group-item list-group-item-action d-flex justify-content-between align-items-center ${isActive ? "active" : ""}`}
                onClick={() => handleSwitchContext(item.id_user_group)}
                disabled={loading || isActive}
              >
                <span>
                  <i className={`fas ${isActive ? "fa-check-circle" : "fa-user-shield"} mr-2`} />
                  {getContextLabel(item)}
                </span>
                {isActive ? <span className="badge badge-light">Aktif</span> : null}
              </button>
            );
          })}
          {contextItems.length < 1 ? (
            <div className="text-muted">Tidak ada peran/context yang tersedia.</div>
          ) : null}
          {loading ? (
            <div className="text-muted mt-3">
              <i className="fas fa-spinner fa-spin mr-2" />
              Memproses pergantian peran...
            </div>
          ) : null}
        </div>
      </PopupDialog>
    </nav>
  );
}
